import { render } from "./TemplatePagination.vue?vue&type=template&id=52aa8a04"
import script from "./TemplatePagination.vue?vue&type=script&lang=js"
export * from "./TemplatePagination.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__